export enum PointsHistoryClassification {
  EARNED = 'earned',
  REDEEMED = 'redeemed',
  RESERVED = 'reserved',
}
